import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import setOpenMobileMenu from '../../actions/setOpenMobileMenu';
import isActive from '../../utils/isActive';
import { inject, observer } from 'mobx-react'
import { withRouter } from 'react-router';

class SideMenuItem extends Component {
  render() {

    //console.log('render nav link!',this.props.router);

    return (
      <Link onClick={()=>{this.props.appStateStore.show_mobile_menu=false; }} className={`db clear tdni w5 fs16 hpadd20 vpadd10 trans03 bg-w1-op100 bg-w2-op50-hover sideMenuItem ${isActive(this.props.router, this.props.route, this.props.regexp)?'active bg-w2':''}`} to={this.props.route} >
          {this.props.name}
      </Link>
    )
  }
}

function mapStateToProps(state) {
  return {
    router:state.router,
  }
}

// export default connect(mapStateToProps,{ setOpenMobileMenu })(SideMenuItem);
export default withRouter(inject("router","appStateStore")(observer(SideMenuItem)));